export interface DeterministicHookOptions {
  stepMs: number;
  renderToText: () => string;
  onAdvanceStep: (stepMs: number) => void;
}

export interface DeterministicHookBindings {
  boundRenderGameToText: () => string;
  boundAdvanceTime: (ms: number) => void;
}

export function installDeterministicHooks(
  options: DeterministicHookOptions
): DeterministicHookBindings | null {
  if (typeof window === 'undefined') return null;

  const boundRenderGameToText = options.renderToText;
  const boundAdvanceTime = (ms: number) => {
    const steps = Math.max(1, Math.round(ms / options.stepMs));
    for (let i = 0; i < steps; i += 1) {
      options.onAdvanceStep(options.stepMs);
    }
  };

  window.render_game_to_text = boundRenderGameToText;
  window.advanceTime = boundAdvanceTime;

  return {
    boundRenderGameToText,
    boundAdvanceTime,
  };
}

export function uninstallDeterministicHooks(bindings: DeterministicHookBindings | null): void {
  if (!bindings || typeof window === 'undefined') return;

  if (window.render_game_to_text === bindings.boundRenderGameToText) {
    window.render_game_to_text = undefined;
  }

  if (window.advanceTime === bindings.boundAdvanceTime) {
    window.advanceTime = undefined;
  }
}
